import React from "react";
import AdminHeader from "../../../../components/admin/AdminHeader";
import { AdminFooter } from "../../../../components/admin/AdminFooter";
import AdminFaqAdd from "../../../../views/admin/cms/faqs/AdminFaqAdd";

const AdminFaqAddPage = () => {
  window.scrollTo(0, 0);

  return (
    <div>
      <AdminHeader />
        <AdminFaqAdd />
      <AdminFooter />
    </div>
  );
};

export default AdminFaqAddPage;
